import React from 'react'
import classnames from 'classnames'
import { ResourceComponent } from '../DayItem'
import { useSelector } from 'react-redux'

export default function Day({ resources, index, date }) {
  const { organization, dateFilter } = useSelector(state=>state)
  return (
    <div 
      className={classnames("p-1 d-inline-block",{"border-left": index != 0, "selected": date == dateFilter.date })} 
      style={{height: '100%', width: 'calc((100%) / 7)', verticalAlign: 'top'}}>
      {
        resources.map((resource, index) => (
          <ResourceComponent key={index} {...resource} organization={organization}/>
        ))
      }
    </div>
  )
}